export type LatLng = [lat: number, lng: number];
export type LatLngBounds = [ne: LatLng, sw: LatLng];

export const LATLNG_BUDAPEST: LatLng = [47.4925, 19.051389];
